import { Component, OnInit } from '@angular/core';
import {
  faUserLock,
} from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-bye',
  templateUrl: './bye.component.html',
  styleUrls: ['./bye.component.scss']
})
export class ByeComponent implements OnInit {

  public faUserLock = faUserLock;

  constructor() { }

  ngOnInit(): void {
  }

}
